import { css } from '../util';
import colorBoard from './colorBoard';
import setLineWidth from './setLineWidth';

export default function toolbarMiddleArea (me) {
  const clientHeight = document.documentElement.clientHeight;
  const toolbarMiddleArea = document.createElement('span');
  toolbarMiddleArea.id = 'kssToolbarMiddleArea';

  toolbarMiddleArea.appendChild(colorBoard(me));
  toolbarMiddleArea.appendChild(setLineWidth(me));

  return toolbarMiddleArea;
}
